// Endpoint connections for RF.Core.API AccountController

import { Get, Post } from 'api/requests';

export const joinTypes = {
    Join: 'Join',
    JoinFromGuid: 'JoinFromGuid',
    JoinToMerge: 'JoinToMerge'
}

const routes = {
    GetAccountCreateSettings: `${process.env.REACT_APP_API_ROOT_URL}/rfcoreapi/%TENANT%/account/getaccountcreatesettings`,
    GetParticipantPerson: `${process.env.REACT_APP_API_ROOT_URL}/rfcoreapi/%TENANT%/account/getparticipantperson`,
    SubmitParticipantAccount: `${process.env.REACT_APP_API_ROOT_URL}/rfcoreapi/%TENANT%/account/%OPERATION%%TYPE%participantaccount`,
    UpdateEmailAddress: `${process.env.REACT_APP_API_ROOT_URL}/rfcoreapi/%TENANT%/account/updateemailaddress`,
    UpdatePhoneNumber: `${process.env.REACT_APP_API_ROOT_URL}/rfcoreapi/%TENANT%/account/updatephonenumber`,
    RequestEmailConfirmation: `${process.env.REACT_APP_API_ROOT_URL}/rfcoreapi/%TENANT%/account/requestemailconfirmation`,
    CheckEmailVerification: `${process.env.REACT_APP_API_ROOT_URL}/rfcoreapi/%TENANT%/account/checkemailverification`,
    RequestPhoneVerification: `${process.env.REACT_APP_API_ROOT_URL}/rfcoreapi/%TENANT%/account/requestphoneverification`,
    CheckPhoneVerification: `${process.env.REACT_APP_API_ROOT_URL}/rfcoreapi/%TENANT%/account/checkphoneverification`,
    PreAuthenticateParticipant: `${process.env.REACT_APP_API_ROOT_URL}/rfcoreapi/%TENANT%/account/preauthenticateparticipant`,
    CheckAccountConflict: `${process.env.REACT_APP_API_ROOT_URL}/rfcoreapi/%TENANT%/account/checkaccountconflict`,
    LookupPhoneLine: `${process.env.REACT_APP_API_ROOT_URL}/rfcoreapi/%TENANT%/phonenumber/lookupphoneline`,
    IsNotDuplicateUsernameCheck: `%PUBLICURL%/account/doesusernamenotexist`,
    ForgotPassword: `%PUBLICURL%/account/forgotpassword`
}

export function getAccountCreateSettings(bearer, tenant) {

    let getUrl = routes.GetAccountCreateSettings.replace('%TENANT%', tenant);

    return Get({
        url: getUrl,
        bearer: bearer
    });
}

export function getParticipant(joinType, bearer, tenant) {

    if (joinType !== joinTypes.JoinFromGuid)
        return null;

    let getUrl = routes.GetParticipantPerson.replace('%TENANT%', tenant);

    return Get({
        url: getUrl,
        bearer: bearer
    });
}

export function submitParticipantAccount(participantData, joinType, bearer, tenant) { 

    let type = participantData.isPediatric ? 'pediatric' : 'adult';
    let operation = (joinType === joinTypes.JoinFromGuid) ? 'update' : 'create';
    let postUrl = routes.SubmitParticipantAccount.replace('%TENANT%', tenant).replace('%OPERATION%', operation).replace('%TYPE%', type);

    return Post({
        url: postUrl,
        bearer: bearer,
        data: participantData
    });
}

export function updateEmailAddress(emailAddressChange, bearer, tenant) {

    let postUrl = routes.UpdateEmailAddress.replace('%TENANT%', tenant);

    return Post({
        url: postUrl,
        bearer: bearer,
        data: emailAddressChange
    });
}

export function updatePhoneNumber(phoneNumberChange, bearer, tenant) {

    let postUrl = routes.UpdatePhoneNumber.replace('%TENANT%', tenant);

    return Post({
        url: postUrl,
        bearer: bearer,
        data: phoneNumberChange
    });
}

export function requestEmailConfirmation(emailRequestVerify, bearer, tenant) {

    let postUrl = routes.RequestEmailConfirmation.replace('%TENANT%', tenant);

    return Post({
        url: postUrl,
        bearer: bearer,
        data: emailRequestVerify
    });
}

export function checkEmailVerification(emailAddressCheckVerify, bearer, tenant) {

    let postUrl = routes.CheckEmailVerification.replace('%TENANT%', tenant);

    return Post({
        url: postUrl,
        bearer: bearer,
        data: emailAddressCheckVerify
    });
}

export function requestPhoneVerification(phoneNumberRequestVerify, bearer, tenant) {
    let postUrl = routes.RequestPhoneVerification.replace('%TENANT%', tenant);
    
    return Post({
        url: postUrl,
        bearer: bearer,
        data: phoneNumberRequestVerify
    });
}

export function checkPhoneVerification(phoneNumberCheckVerify, bearer, tenant) {
    let postUrl = routes.CheckPhoneVerification.replace('%TENANT%', tenant);

    return Post({
        url: postUrl,
        bearer: bearer,
        data: phoneNumberCheckVerify
    });
}

export function checkAccountConflict(duplicateCheckData, bearer, tenant) {
    let postUrl = routes.CheckAccountConflict.replace('%TENANT%', tenant);

    return Post({
        url: postUrl,
        bearer: bearer,
        data: duplicateCheckData
    });
}

export function lookupPhoneLine(phoneLookupData, bearer, tenant) {
    let postUrl = routes.LookupPhoneLine.replace('%TENANT%', tenant);

    return Post({
        url: postUrl,
        bearer: bearer,
        data: phoneLookupData
    });
}

export function checkIsNotDuplicateUsername(duplicateCheckData, publicUrl) {
    let postUrl = routes.IsNotDuplicateUsernameCheck.replace('%PUBLICURL%', publicUrl);

    return Post({
        url: postUrl,
        data: duplicateCheckData,
        isJson: false
    });
}
export function sendForgotPasswordEmail(forgotPasswordData, publicUrl) {
    let postUrl = routes.ForgotPassword.replace('%PUBLICURL%', publicUrl);

    return Post({
        url: postUrl,
        data: forgotPasswordData,
        isJson: false
    });
}

export function requestPreAuthenticateParticipant(bearer, tenant) {
    let getUrl = routes.PreAuthenticateParticipant.replace('%TENANT%', tenant);

    return Get({
        url: getUrl,
        bearer: bearer
    });
}